import { sample } from 'effector';
import { logoutSucceeded } from '~/entities/auth';
import { createPagination } from '~/shared/lib/pagination';

export const paginationModel = createPagination();

sample({
    clock: logoutSucceeded,
    target: paginationModel.reset,
});
